/**
 * Scroll the audience/dashboard shell to the top of the main content.
 * Runs after the next paint so pagination (or other) React updates can settle first.
 *
 * Prefer `scrollIntoView` on the dashboard content root so the correct scrollport
 * (`<main class="overflow-y-auto">`) is driven, then clear any document scroll.
 */
export function smoothScrollAudiencePageTop() {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const content = document.getElementById("dashboard-main-content");
      if (content && typeof content.scrollIntoView === "function") {
        content.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      } else {
        const main = document.querySelector("main.overflow-y-auto");
        if (main && typeof main.scrollTo === "function") {
          main.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
      }
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    });
  });
}
